<template>
  <div>
    <item-select v-model="dd"
                 :disabled="disabled"
                 v-if="list !== null && list !== undefined"
                 :options="options"
                 :multiple="multiple" />
    <div style="width: 120px"
         v-else>
      <el-input v-model="dd"
                :disabled="disabled"
                size="small"></el-input>
    </div>
  </div>
</template>
<script>
import LibProductItem from '../../../minxin/ProductItem';

export default {
  name: "ProductItemTypeInt",
  mixins: [LibProductItem],
  props: {
    value: [Number, Array],
  },
  computed: {
    dd: {
      get: function () { return this.value },
      set: function (n) {
        if (this.multiple) {
          for (let i in n) {
            let v = n[i]
            if (/^\d{0,10}$/.exec(v) === null) {
              return;
            }

            v = parseInt(v) || 0

            n[i] = v
          }
        } else {
          if (/^\d{0,10}$/.exec(n) === null) {
            return;
          }

          if (n === "") {
            n = null
          } else {
            n = parseInt(n) || 0
          }
        }
        this.$emit('input', n)
      }
    },
    options() { return this.list }
  }
}
</script>
